import { Component, Input } from '@angular/core';
import { EditOrderService } from '../../../services/edit-order.service';

@Component({
  selector: 'common-edit-order-contact-us-button',
  templateUrl: './edit-order-contact-us-button.component.html',
  styleUrls: ['./edit-order-contact-us-button.component.scss'],
})
export class EditOrderContactUsButtonComponent {
  @Input() brandColor?: string;
  @Input({ required: true }) trackableText!: string;

  constructor(private editOrderService: EditOrderService) {}
  onClick() {
    this.editOrderService.contactUs.emit();
  }
}
